import { Component, OnInit, Input, OnChanges, OnDestroy, ElementRef, HostListener } from '@angular/core';
import { FormGroup, FormControl } from '@angular/forms';
import { EMPTY, Subscription } from 'rxjs';
import { BroadcastingsService } from 'src/app/services/broadcastings-services/broadcastings.service';
import { SnackBarService } from 'src/app/components/shared-components/snack-bar/snack-bar.service';
import { SocialNetwork } from 'src/app/models/broadcastings-models/socialnetwork.model';
import { tap } from 'rxjs/internal/operators/tap';
import { catchError } from 'rxjs/internal/operators/catchError';

@Component({
  selector: 'app-broadcastings-tv-format-twitter-info-card',
  templateUrl: './broadcastings-tv-format-twitter-info-card.component.html',
  styleUrls: ['./broadcastings-tv-format-twitter-info-card.component.scss']
})
export class BroadcastingsTvFormatTwitterInfoCardComponent implements OnInit, OnChanges, OnDestroy {
  @Input() tvFormatDeviceInfo;
  socialNameToken = 'TWITTER';
  editingLocked: boolean;
  twitterPlaceholder;
  srcDoc;
  updateTvFormatWidgetSubscription: Subscription;
  basicDataForm = new FormGroup({
    active: new FormControl({value: false, disabled: true}),
    contentCode: new FormControl({value: null, disabled: false})
  });

  constructor(private eRef: ElementRef,
    private broadcastingsService: BroadcastingsService,
    private snackBarService: SnackBarService) {
    }

  ngOnInit() {
    this.editingLocked = true;
    this.twitterPlaceholder = 'Example: \n<a class="twitter-timeline" href="https://twitter.com/Infos_France?ref_src=twsrc%5Etfw">Tweets by Infos_France</a> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>';
  }

  ngOnChanges() {
    if (this.tvFormatDeviceInfo) {
      this.resetForm();
      this.lockEdition();
      if (this.basicDataForm.get('contentCode')) {
        this.updateSrcDoc();
      }
    }
  }

  @HostListener('document:click', ['$event'])
  clickout(event) {
    if (this.eRef.nativeElement.contains(event.target)) {

    } else {
      if (event.path[0].className !== 'mat-option-text') {
        if (this.tvFormatDeviceInfo && !this.editingLocked) {
          this.resetForm();
          this.lockEdition();
          this.editingLocked = true;
        }
      }
    }
  }

  private submitForm() {
      let socialNetworks = new Array<SocialNetwork>();
      socialNetworks = this.tvFormatDeviceInfo.SocialNetworkList;
      let missingSocialNetwork = true;
      socialNetworks.forEach(
        (sn) => {
          if (sn.SocialName === this.socialNameToken) {
            sn.Active = this.basicDataForm.get('active').value;
            sn.ContentCode = this.basicDataForm.get('contentCode').value;
            missingSocialNetwork = false;
          }
        }
      );
      if (missingSocialNetwork) {
        const emptySocialNetwork = new SocialNetwork();
        emptySocialNetwork.SocialName = this.socialNameToken;
        emptySocialNetwork.Active = this.basicDataForm.get('active').value;
        emptySocialNetwork.ContentCode = this.basicDataForm.get('contentCode').value;
        socialNetworks.push(emptySocialNetwork);
      }
      this.updateTvFormatWidgetSubscription = this.broadcastingsService.updateTvFormatWidget(this.tvFormatDeviceInfo.InternalId, socialNetworks, this.tvFormatDeviceInfo.checkPrincipalDesk, this.tvFormatDeviceInfo.principalDeskInternalId).pipe(
        tap(o => this.snackBarService.open('devices-page.snackbar messages.update device success', 'success')),
        tap(o => this.lockEdition()),
        tap(o => this.broadcastingsService.refreshTvFormat()),
        catchError(error => { this.snackBarService.open(error['error']['message'], 'error'); return EMPTY; })
      ).subscribe();
  }

  public toggleEdition() {
    if (this.editingLocked) {
      this.unlockEdition();
    } else {
      const validation = this.validateForm();
      if (validation === true) {
        this.submitForm();
      } else {
        this.snackBarService.open(validation, 'error');
      }
    }
  }

  private validateForm() {
    if (this.basicDataForm.get('active').value && !this.basicDataForm.get('contentCode').value) {
      return 'broadcastings-page.snackbar messages.widget content error';
    } else {
      return true;
    }
  }

  private resetForm() {
    this.basicDataForm.patchValue({
      active: this.setSocialNetworkActive(),
      contentCode: this.setSocialNetworkContentCode()
    });
  }

  private unlockEdition() {
    this.basicDataForm.get('active').enable();
    this.basicDataForm.get('contentCode').enable();
    this.editingLocked = false;
  }

  private lockEdition() {
    this.basicDataForm.get('active').disable();
    this.basicDataForm.get('contentCode').disable();
    this.editingLocked = true;
  }

  public setSocialNetworkActive() {
    if (this.tvFormatDeviceInfo) {
      for (const socialNetwork of this.tvFormatDeviceInfo.SocialNetworkList) {
        if (socialNetwork.SocialName === this.socialNameToken) {
          return socialNetwork.Active;
        }
      }
    }
  }

  public setSocialNetworkContentCode() {
    if (this.tvFormatDeviceInfo) {
      for (const socialNetwork of this.tvFormatDeviceInfo.SocialNetworkList) {
        if (socialNetwork.SocialName === this.socialNameToken) {
          return socialNetwork.ContentCode;
        }
      }
    }
  }

  public setPreselected(op1, op2) {
    if (op1 && op2) {
      return op1.InternalId === op2.InternalId;
    }
  }

  private updateSrcDoc() {
    if (this.tvFormatDeviceInfo) {
      this.srcDoc = this.basicDataForm.get('contentCode').value;
    }
  }

  ngOnDestroy() {
    if (this.updateTvFormatWidgetSubscription) { this.updateTvFormatWidgetSubscription.unsubscribe(); }
  }

}
